import React from 'react';
import { Button } from './ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';
import { 
  Move, 
  RotateCw, 
  ZoomIn, 
  ZoomOut, 
  Maximize2,
  Hand
} from 'lucide-react';
import useStore from '../store/useStore';

function MouseHintIcon({ highlight = 'none', className = '' }) {
  // Простая SVG-иконка мыши с подсветкой ЛКМ/ПКМ
  const leftOn = highlight === 'left' || highlight === 'both';
  const rightOn = highlight === 'right' || highlight === 'both';
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      className={className}
    >
      {/* Корпус */}
      <rect x="7" y="2.5" width="10" height="19" rx="5" fill="none" stroke="currentColor" strokeWidth="1.5" opacity="0.9" />
      {/* Разделитель кнопок */}
      <path d="M12 3.5v6.5" stroke="currentColor" strokeWidth="1.5" opacity="0.5" />
      {/* Левая кнопка */}
      <path
        d="M7.75 7.5V7.2c0-2.2 1.9-4 4.25-4h0v6.3H7.75z"
        fill="currentColor"
        opacity={leftOn ? 0.9 : 0.18}
      />
      {/* Правая кнопка */}
      <path
        d="M16.25 7.5V7.2c0-2.2-1.9-4-4.25-4h0v6.3h4.25z"
        fill="currentColor"
        opacity={rightOn ? 0.9 : 0.18}
      />
      {/* Колесо */}
      <rect x="11.25" y="6" width="1.5" height="3.3" rx="0.75" fill="currentColor" opacity="0.55" />
    </svg>
  );
}

export default function BottomToolbar() {
  const { transformMode, setTransformMode, selectedPlacedId } = useStore();

  return (
    <TooltipProvider>
      <div 
        className="pointer-events-auto absolute bottom-4 left-1/2 -translate-x-1/2 z-10 glass-dark text-white px-6 py-3 rounded-full shadow-2xl hidden md:flex items-center gap-4"
        data-testid="bottom-toolbar"
      >
        {/* Transform tools */}
        <div className="flex items-center gap-2">
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant={transformMode === 'translate' ? 'secondary' : 'ghost'}
                size="icon"
                className="h-9 w-9"
                onClick={() => setTransformMode('translate')}
                disabled={!selectedPlacedId}
                data-testid="toolbar-move-btn"
              >
                <Move className="h-4 w-4" />
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              <p>Перемещение (W)</p>
            </TooltipContent>
          </Tooltip>

          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant={transformMode === 'rotate' ? 'secondary' : 'ghost'}
                size="icon"
                className="h-9 w-9"
                onClick={() => setTransformMode('rotate')}
                disabled={!selectedPlacedId}
                data-testid="toolbar-rotate-btn"
              >
                <RotateCw className="h-4 w-4" />
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              <p>Вращение (E)</p>
            </TooltipContent>
          </Tooltip>
        </div>

        {/* Divider */}
        <div className="hidden md:block h-6 w-px bg-white/20" />

        {/* Camera controls info - hidden on mobile (mouse hints are irrelevant) */}
        <div className="hidden md:flex items-center gap-2 text-xs text-white/70">
          <MouseHintIcon highlight="left" className="h-4 w-4 text-white/80" />
          <span><span className="font-semibold text-white/90">ЛКМ</span> - вращение</span>
          <span className="mx-1">|</span>
          <span>Колесо - зум</span>
          <span className="mx-1">|</span>
          <MouseHintIcon highlight="right" className="h-4 w-4 text-white/80" />
          <span><span className="font-semibold text-white/90">ПКМ</span> - панорама</span>
        </div>
      </div>
    </TooltipProvider>
  );
}
